module.exports = __webpack_public_path__ + "img/arrow-up.c15e4c9d.svg";